import React from 'react';

// @material-ui/core components
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

export default class CustomSelect extends React.Component {
	handleChange = ({ target: { value } }, { props: { children } }) => {
		this.props.onChange(value, children);
	}

	render() {
		const {
			label,
			items,
			value,
			multiple,
			propStyles = {}
		} = this.props;

		const styles = {
			select: {
				fontSize: '14px',
			},
			menuItem: {
				fontSize: '14px',
			},
			...propStyles,
		};

		return (
			<FormControl fullWidth>
				<InputLabel htmlFor="simple-select">
					{label}
				</InputLabel>
				<Select
					style={styles.select}
					value={value}
					multiple={multiple}
					onChange={this.handleChange}
					inputProps={{
						name: "simpleSelect",
						id: "simple-select"
					}}
				>
					{items.map((item, index) => (
						<MenuItem
							style={styles.menuItem}
							key={index}
							value={item.value || item}
						>
							{item.label || item}
						</MenuItem>
					)) }
				</Select>
			</FormControl>
		)
	}
}
